import { tv } from 'tailwind-variants';

import { createInlineTextComponent, type InlineTextProps } from './utils';

const emphasisVariants = tv({
    base: 'font-kalshi-sans',
    variants: {
        size: {
            x10: 'typ-emphasis-x10',
            x20: 'typ-emphasis-x20',
            x30: 'typ-emphasis-x30',
            x40: 'typ-emphasis-x40',
        },
        medium: {
            true: 'font-medium',
        },
        semibold: {
            true: 'font-semibold',
        },
        tabularNums: {
            true: 'typ-tabular',
        },
        underline: {
            true: 'underline-link',
        },
    },
    defaultVariants: {
        tabularNums: false,
        underline: false,
    },
});

/**
 * Emphasis Components
 *
 * Medium-weight text for UI labels and emphasized content.
 * Uses KalshiSans Medium font.
 *
 * @example
 * <Emphasis.x20>Submit</Emphasis.x20>
 * <Emphasis.x20 underline>Learn more</Emphasis.x20>
 * <Emphasis.x30 tabularNums>$1,234.56</Emphasis.x30>
 */
export const Emphasis = {
    /** Emphasis x10 - 12px/16px, KalshiSans Medium */
    x10: createInlineTextComponent(emphasisVariants, 'Emphasis.x10', 'x10'),
    /** Emphasis x20 - 13px/18px, KalshiSans Medium */
    x20: createInlineTextComponent(emphasisVariants, 'Emphasis.x20', 'x20'),
    /** Emphasis x30 - 15px/22px, KalshiSans Medium */
    x30: createInlineTextComponent(emphasisVariants, 'Emphasis.x30', 'x30'),
    /** Emphasis x40 - 18px/26px, KalshiSans Medium */
    x40: createInlineTextComponent(emphasisVariants, 'Emphasis.x40', 'x40'),
} as const;

export default Emphasis;
export { emphasisVariants };
export type EmphasisProps = InlineTextProps;
